import { UseQueryResult } from 'react-query';

import { RewardTransaction } from '@jebel/constants';

import { useCurrentUser } from 'shared/hooks';

import { useUserRewardAccountHistory } from './useUserRewardAccountHistory';

export const CURRENT_USER_REWARD_HISTORY_QUERY_KEY = 'CURRENT_USER_REWARD_HISTORY';

/**
 * React hook to fetch the current user's reward account history (transactions) for the selected community.
 *
 * Uses React Query to asynchronously retrieve reward transaction data from the tracking API.
 * The query is enabled only if the current user's reward account is available.
 *
 * @returns {UseQueryResult<RewardTransaction[]>} The query result containing the reward transaction history.
 * @throws {Error} If the current user's reward account is not available, or if the fetch fails.
 */
export function useCurrentUserRewardAccountHistory(): UseQueryResult<RewardTransaction[]> {
  const { user: currentUser } = useCurrentUser();

  return useUserRewardAccountHistory(currentUser);
}
